import React, { Component } from 'react'
import style from './EditNode.scss'
import ColorPicker from '../ColorPicker/ColorPicker'

class EditNode extends Component {
  constructor() {
    super()
    this.state = { expanded: false, displayColorPicker: false }
  }
  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded })
  }
  render() {
    return (
      <div className={style.editNode}>
        <div
          className={style.label}
          data-expanded={this.state.expanded}
          onClick={this.toggleExpanded.bind(this)}
        >
          {this.props.title}
        </div>
        <div
          className={style.bodyWrap}
          style={{
            transition: 'max-height .3s ease',
            maxHeight: this.state.expanded ? '50em' : '0'
          }}
        >
          <div className={style.body}>
            {this.props.children
              ? this.props.children
              : Object.entries(this.props.data).map((node, key) => {
                  return (
                    <ColorPicker
                      group={this.props.group}
                      node={node}
                      key={key}
                      updateTheme={this.props.updateTheme}
                    />
                  )
                })}
          </div>
        </div>
      </div>
    )
  }
}

export default EditNode



// WEBPACK FOOTER //
// ./src/components/EditNode/EditNode.js